import React, {useEffect, useState} from "react";
import {TabPanel, TabView} from "primereact/tabview";
import FileUploader from "../../../../components/fileUploader/FileUploader";
import FileService from "../../../../service/FileService";
import {Button} from "primereact/button";
import {toast} from 'react-toastify';
// import Toogle from "./Toogle";
import {FILE_URL} from "../../../../utils/Constants";
import {Editor} from "primereact/editor";
import GeneralUtils from "../../../../utils/GeneralUtils";
import {LectureService} from "../../../../service/LectureService";
import Loading from "../../../../components/loading/Loading";
import {SplitButton} from "primereact/splitbutton";
import {Divider} from "primereact/divider";
import {AssetService} from "../../../../service/AssetService";
import { FileUpload } from 'primereact/fileupload';
import {InputText} from "primereact/inputtext";
import FileUploaderForPDF from "../../../../components/fileUploader/FileUploaderForPDF";
import SupplementaryAsset from "./SupplementaryAsset";

const defaultData = [{title: "Giriş", objectIndex: 1}];
const Asset = (props) => {
    const {course, lecture, setLecture, file, videoFile, setVideoFile} = props;
    const [data, setData] = useState(lecture?.asset ? lecture.asset : {});
    const [body, setBody] = useState(lecture.asset?.body);
    const [toggleType, setToggleType] = useState(null); // 'Video' | 'Article' | 'Presentation' | 'Resource'
    const [loading, setLoading] = useState(false);

    const service = new AssetService();
    const lectureService = new LectureService();

    const items = [
        {
            label: 'Video Ekle',
            icon: 'pi pi-video',
            command: () => setToggleType('Video')
        },
        {
            label: 'Makale Ekle',
            icon: 'pi pi-book',
            command: () => setToggleType('Article')
        },
        {
            label: 'Sunum Ekle',
            icon: 'pi pi-file',
            command: () => setToggleType('Presentation')
        }
        // ,
        // {
        //     label: 'Dış Kaynak',
        //     icon: 'pi pi-external-link',
        //     command: () => {
        //         // window.location.href = 'https://reactjs.org/';
        //     }
        // }
    ];

    const fileService = new FileService();

    useEffect(() => {
        setLecture(data);
    }, [data]);

    const onUpload = (file) => {
        if(file){
            if (file.size > 1024 * 1024 * 1024) {
                return toast.warn("Dosyaların boyutu, her dosya için 1 GB'dan küçük olmalıdır!");
            }
            setLoading(true);
            fileService.upload(getVideoForm(file)).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && (GeneralUtils.isNullOrEmpty(response.type) || response.type === "SUCCESS")
                    && GeneralUtils.isNullOrEmpty(response.error)){
                    // setVideoFile(file);
                    setToggleType(null);
                    let asset = {
                        timeEstimation: file.duration,
                        lecture: lecture,
                    };
                    service.updateTimeEstimation(asset).then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            setData(response);
                        }
                    });
                    // lectureService.findById(lecture.id).then((response) => {
                    //     if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    //         setData(response.asset);
                    //     }
                    // });
                }
                setLoading(false);
            });
        }
        // setData(getDataFromFile(file));
    }

    const getVideoForm = (videoFile) => {
        const videoForm = new FormData();
        videoForm.append('file', videoFile);
        videoForm.append('name', videoFile.name);
        videoForm.append('path', "lecture");
        videoForm.append('id', lecture.id);
        return videoForm;
    }


    const onUploadPresentation = (file) => {
        if(file){
            if (file.size > 1024 * 1024 * 1024) {
                return toast.warn("Dosyaların boyutu, her dosya için 1 GB'dan küçük olmalıdır!");
            }
            setLoading(true);
            fileService.upload(getFileForm(file)).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && (GeneralUtils.isNullOrEmpty(response.type) || response.type === "SUCCESS")
                    && GeneralUtils.isNullOrEmpty(response.error)){
                    // setVideoFile(file);
                    setToggleType(null);
                    lectureService.findById(lecture.id).then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            setData(response.asset);
                        }
                    });
                }
                setLoading(false);
            });
        }
    };

    const getFileForm = (file) => {
        const form = new FormData();
        form.append('file', file);
        form.append('name', file.name);
        form.append('path', "lecture");
        form.append('id', lecture.id);
        return form;
    }

    const saveArticle = () => {
        let asset ={
            id: data.id, // Mevcut id'yi koru
            title: lecture.title,
            body: body,
            assetType: 'Article',
            lecture: lecture
        }

        // Eğer asset id'si varsa güncelle, yoksa yeni oluştur
        const saveMethod = data.id ? service.update(asset) : service.create(asset);

        saveMethod.then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                setData(response);
                setToggleType(null);
            }
        });
    }



    const getDataFromFile=(file)=> {
        let videoUrl = file ? FILE_URL + file.name : null;
        return {title: file.name, filename: file.name, assetType: 'Video', videoUrl: videoUrl, timeEstimation: file.duration};
    }

    // const header = (
    //     <span className="ql-formats">
    //             <button className="ql-bold" aria-label="Bold"></button>
    //             <button className="ql-italic" aria-label="Italic"></button>
    //             <button className="ql-underline" aria-label="Underline"></button>
    //             <button className="ql-strike" aria-label="Strike"></button>
    //         </span>
    // );

    const getVideoContent = (
        <>
            {/*<TabView>*/}
            {/*    <TabPanel header="Video Yükle">*/}
                    <FileUploader type="video" name={`${data.id}-video`} src={data.videoUrl}
                                  accept=".avi,.mpg,.mpeg,.flv,.mov,.m2v,.m4v,.mp4,.rm,.ram,.vob,.ogv,.webm,.wmv"
                                  onUpload={file => {
                                      onUpload(file)
                                  }} file={videoFile}
                                  label="Not: Tüm dosyalar en az 720p çözünürlüğe sahip olmalı ve boyutu 1 GB'ı aşmamalıdır."/>
                    {loading && <Loading/>}
            {/*    </TabPanel>*/}
            {/*    <TabPanel header="Kitaplıktan Ekle">*/}
            {/*        <AssetList course={course}/>*/}
            {/*    </TabPanel>*/}
            {/*</TabView>*/}
        </>
    )

    const articleContent = (
        <>
            <div className="flex flex-column gap-2 mb-2">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-book mr-2"></i>
                        <b>Makale</b>
                    </div>
                </Divider>
                <Editor id="body" value={body} onTextChange={(e) => setBody(e.htmlValue)}
                        // headerTemplate={header}
                        style={{height: '200px'}}/>
                <Button label="Kaydet" raised size="small" onClick={saveArticle}/>
            </div>
        </>
    )

    const presentationContent = (
        <>
            <FileUploaderForPDF name={`${data.id}-file`}  accept=".pdf"
                                onUpload={file => {
                                    onUploadPresentation(file)
                                }} src={data.downloadUrl}
                                label="Not: Sadece PDF dosyasına izin verilir."/>
        </>
    )

    return (
        <>

            {/*{(data?.assetType === 'Video') &&*/}
            {/*    <Divider align="left">*/}
            {/*        <div className="inline-flex align-items-center">*/}
            {/*            <i className={(data?.assetType === 'Video') ? "pi pi-video mr-2" : "pi pi-book mr-2"}></i>*/}
            {/*            <b>İçerik: {data.filename}</b>*/}
            {/*        </div>*/}
            {/*    </Divider>*/}
            {/*}*/}


            {GeneralUtils.isNullOrEmpty(data) &&
                <div>
                    <SplitButton label="İçerik Ekle" icon="pi pi-plus" onClick={() => setToggleType(toggleType !== 'Video' ? 'Video' : null)} model={items} outlined size="small"/>
                </div>
            }

            {(toggleType !== null) &&
                <Button icon="pi pi-times" rounded text severity="secondary" aria-label="Close"
                    onClick={() => setToggleType(null)}/>}

            {(toggleType === 'Video' || data?.assetType === 'Video') && getVideoContent}
            {(toggleType === 'Article' || data?.assetType === 'Article') && articleContent}
            {(toggleType === 'Presentation' || data?.assetType === 'Presentation') && presentationContent}

            <SupplementaryAsset
                lecture={lecture}
                mainAssetType={data?.assetType}
            />
        </>

    )
};

export default Asset;
